import { useAuthStore, useNotificationsStore, useToastStore, usePermissionsStore } from './modules';

import { useEnhancedAuth, useEnhancedNotifications } from './composables';

export function initializeStores() {
    const authStore = useAuthStore();
    const notificationsStore = useNotificationsStore();
    const toastStore = useToastStore();
    const permissionsStore = usePermissionsStore();

    if (authStore.isAuthenticated) {
        notificationsStore.loadNotificationCount();
        notificationsStore.loadRecentNotifications();
        permissionsStore.fetchPermissions();
    }

    return {
        authStore,
        notificationsStore,
        toastStore,
        permissionsStore
    };
}

export {
    useAuthStore,
    useNotificationsStore,
    useToastStore,
    usePermissionsStore,
    useEnhancedAuth,
    useEnhancedNotifications
};